import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { StartOverButton } from './start_over_button';

/**
 * ErrorMessage functional component
 * @param {Object} props - the set of required props
 * @param {Object} props.error - error payload
 * @param {Function} props.dispatch - redux's dispatch
 * @param {Object} props.response - server error response, optional
 * @returns {Node} error message html
 * @constructor
 */
const ErrorMessage = ({ error = {}, dispatch, response }) => {
    const {
        modalTitle = `Whoops, sorry... ${response.status} ${response.statusText}`,
        modalSubTitle = 'looks like something went wrong.',
        modalMessage = 'You have experienced a technical error. We apologise. We are working to correct this issue. Please wait a few moments and try again.',
        startOverButton = false
    } = error;

    return (
        <>
            <h1>{modalTitle}</h1>
            <h2>{modalSubTitle}</h2>
            <p>{modalMessage}</p>
            {startOverButton ? <StartOverButton dispatch={dispatch} /> : null}
        </>
    );
};

ErrorMessage.propTypes = {
    error: PropTypes.object,
    dispatch: PropTypes.func.isRequired,
    response: PropTypes.object
};

ErrorMessage.defaultProps = {
    error: {},
    response: {
        status: '',
        statusText: ''
    }
};

export { ErrorMessage };
